import { useShowMessage } from "../../functions/Common/showMessage";
import useFetch from "../../hooks/useFetch";
import { useState } from "react";

export default function useEditConversation() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  const [editLoading, setEditLoading] = useState(false);

  function editConversation(name, key, onSuccess) {
    fetchWrapper({
      endpoint_url: "conversation/editConversation",
      params: {
        name: name,
        key: key,
      },
      setLoading: setEditLoading,
      onSuccess: (fetch_output) => {
        if (!("error" in fetch_output)) {
          showMessage({ type: "success", message: fetch_output.message });
          onSuccess();
        } else {
          showMessage({ message: fetch_output.error });
        }
      },
      onFetchError: () => {
        showMessage({ apiType: "fetch", message: "edit conversation" });
      },
      onResponseError: () => {
        showMessage({ apiType: "response", message: "edit conversation" });
      },
    });
  }

  return { editConversation, editLoading };
}
